import { FreshAsphalt, FreshAsphalt50 } from './palette';

export const tooltipTextColor = FreshAsphalt;
export const tooltipTextColorSecondary = FreshAsphalt50;
